import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IProjects } from "../projectsModal";

export const getAllProjects = createAsyncThunk(
  "Projects/FindAllProjects",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/FindAllProjects`,
        {
          ProjectsTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Projects:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createProjects = createAsyncThunk(
  "Project/InsertProject",
  async (ProjectsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/InsertProject`,
        ProjectsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Projects:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateProjects = createAsyncThunk(
  "Project/UpdateProject",
  async (ProjectsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/UpdateProject`,
        ProjectsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Projects :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProjects = createAsyncThunk(
  "Project/DeleteProject",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/DeleteProject`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Projects :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getProjectsByID = createAsyncThunk(
  "Project/FindByIDProject",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/FindByIDProject`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.IsActive,
        ProjectTitle: result.ProjectTitle,
        ProjectURL: result.ProjectURL,
        Description: result.Description,
        MetaTitle: result.MetaTitle,
        MetaKeyword: result.MetaKeyword,
        MetaDescription: result.MetaDescription,
        MainImage: result.MainImage,
        InnerImages: result.InnerImages,
        IsActive: result.IsActive ? 1 : 2,
      } as IProjects;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Projects :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveProjects = createAsyncThunk(
  "Project/FindAllActiveProject",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Projects/FindAllActiveProject`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Projects:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveProjects = createAsyncThunk(
  "Project/ActiveInActiveProject",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/ActiveInActiveProject`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Projects :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ProjectsImageUpload = createAsyncThunk(
  "Project/ProjectImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/ProjectImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Projects Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProjectImages = createAsyncThunk(
  "Project/InnerImageDelete",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/InnerImageDelete`,
        {
          ID: ID,
        }
      );

      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else if (response.data.Status === 201) {
        throw new Error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.message || "Something went wrong");
      console.error("ERROR : Delete PFS:", error);
      return Promise.reject({
        message: error?.message || "Something went wrong",
      });
    }
  }
);
